import { CouponType } from "@/modules/common/couponObject/gateway/couponObjectApiDto"
import { OutOfBandTransactionStatus } from "@/modules/finances/boxPaymentAtCounter/entities/outOfBandTransactionType"
import { z } from "zod"

export const BoxShopSalesResultDtoSchema = z
  .object({
    id: z.string(),
    checkoutUrl: z.string().nullable(),
  })
  .meta({ id: "BoxShopSalesResultDtoSchema" })

export const BoxShopSalesCouponDtoSchema = z
  .object({
    type: z.enum(CouponType),
    value: z.number(),
  })
  .meta({ id: "BoxShopSalesCouponDtoSchema" })

export const BoxShopSalesItemDtoSchema = z
  .object({
    id: z.string(),
    quantity: z.int32(),
  })
  .meta({ id: "BoxShopSalesItemDtoSchema" })

export const BoxShopSalesInputDtoSchema = z
  .object({
    outOfBand: z.enum(OutOfBandTransactionStatus).nullable(),
    items: z.array(BoxShopSalesItemDtoSchema),
    coupon: BoxShopSalesCouponDtoSchema.nullable(),
    userId: z.string().nullable(),
  })
  .meta({ id: "BoxShopSalesInputDtoSchema" })

export const BoxShopSalesMailDtoSchema = z
  .object({
    id: z.string(),
    userId: z.string().nullable(),
    email: z.string().nullable(),
  })
  .meta({ id: "BoxShopSalesMailDtoSchema" })

export type BoxShopSalesResultDto = z.infer<typeof BoxShopSalesResultDtoSchema>
export type BoxShopSalesCouponDto = z.infer<typeof BoxShopSalesCouponDtoSchema>
export type BoxShopSalesItemDto = z.infer<typeof BoxShopSalesItemDtoSchema>
export type BoxShopSalesInputDto = z.infer<typeof BoxShopSalesInputDtoSchema>
export type BoxShopSalesMailDto = z.infer<typeof BoxShopSalesMailDtoSchema>
